import { useTranslation } from 'react-i18next';

import useModals from 'modals/hooks';

import Modal from 'components/Modal';

import { ButtonText, Container, StyledButton, Subtitle, Title } from './styles';

const NoLogInModal = () => {
    const { t } = useTranslation();

    const { closeModal } = useModals();

    const onClick = () => {
        closeModal();
    };

    return (
        <Modal
            isOpen
            customStyles={{
                padding: 'unset',
            }}
            dataLocator="NoLogInModal"
            dataTestId="NoLogInModal"
        >
            <Container>
                <Title bold center>
                    {t('noLogInModal.title')}
                </Title>
                <Subtitle $mb center>
                    {t('noLogInModal.text')}
                </Subtitle>
                <StyledButton dataLocator="NoLogInModalButton" onClick={onClick}>
                    <ButtonText as="span">{t('noLogInModal.button')}</ButtonText>
                </StyledButton>
            </Container>
        </Modal>
    );
};

export default NoLogInModal;
